import { toDate } from "date-fns";
import api from "../apiInstance"
import { RentalDetailResponse, RentalStatus } from "./interfaces/Channel";
import { PaginatedListResponse } from "./interfaces/paging";
import { CreateChatForRentalDto, CreateChatForRentalResponse, UserRentalDetail } from "./interfaces/Rental"

export const createChatForRental = async (data: CreateChatForRentalDto, productId: number): Promise<CreateChatForRentalResponse> => {
    const res = await api.post<CreateChatForRentalResponse>(process.env.REACT_APP_RENTIC_API_URL! + '/messages/create_channel/' + productId.toString(), data);
    return res.data;
}

export const getUserRentals = async (isProductOwner: boolean, skip: number, take: number,
                                     fromDate?: Date, toDate?: Date, state?: RentalStatus):
    Promise<PaginatedListResponse<UserRentalDetail>> => {
    const rentalsUrlString = isProductOwner ? "seller_rentals" : "buyer_rentals";

    const res = await api
        .get<PaginatedListResponse<UserRentalDetail>>(process.env.REACT_APP_RENTIC_API_URL! + '/rentals/' + rentalsUrlString,
        {params: {
            skip: skip,
            take: take,
            fromDate: fromDate,
            toDate: toDate,
            state: state
    }})

    return res.data;
}

export const activateRental = async (rentalId: number): Promise<number> => {
    const res = await api.post<number>(process.env.REACT_APP_RENTIC_API_URL! + '/rentals/activate/' + rentalId.toString(), {});

    return res.data;
}

export const deleteRental = async (rentalId: number) => {
    const res = await api.delete<number>(process.env.REACT_APP_RENTIC_API_URL! + '/rentals/delete_rental/' + rentalId.toString());

    return res.data;
}

export const leaveRetalChat = async (rentalId: number): Promise<boolean> => {
    const res = await api.post<boolean>(process.env.REACT_APP_RENTIC_API_URL! + '/rentals/leave/' + rentalId.toString());

    return res.data;
}